import { render } from "./preview-image-pod.vue?vue&type=template&id=b34c8b66"
import script from "./preview-image-pod.vue?vue&type=script&lang=js"
export * from "./preview-image-pod.vue?vue&type=script&lang=js"

import "./preview-image-pod.vue?vue&type=style&index=0&id=b34c8b66&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__